import React from "react";
import { TableCell as MuiTableCell } from "@material-ui/core";
import { EditableCellComponent } from "./EditableCell";
import { formatCellValue } from "../utils/formatters";

export const TableCell = ({
  row,
  rowIndex,
  config,
  colKey,
  columnWidths,
  currencySymbol,
  getCellValue,
  getCellStyle,
  onCellChange,
  isFirstColumn = false,
  mainHeader,
  onCellClick,
}) => {
  const rawValue = getCellValue ? getCellValue(row, config.field, rowIndex) : row[config.field];
  const cellStyle = getCellStyle ? getCellStyle(row, config.field) : {};
  
  // Check if this is a Total row - make text bold
  const isTotalRow = row.label === "Total" || row.id === "Total";
  
  // If getCellValue was provided and returned a formatted string, use it directly
  // Otherwise, use config.format or formatCellValue
  let displayValue;
  if (getCellValue && typeof rawValue === "string" && rawValue !== String(row[config.field])) {
    // getCellValue already formatted it
    displayValue = rawValue;
  } else {
    displayValue = config.format
      ? config.format(rawValue)
      : formatCellValue(rawValue, config.type, currencySymbol);
  }
  const width = columnWidths[colKey] || config.width || config.minWidth || 120;

  const isEditable = typeof config.editable === "function" 
    ? config.editable(row)
    : config.editable === true;

  // Use dataAlign if specified, otherwise fall back to align
  const dataAlignment = config.dataAlign !== undefined ? config.dataAlign : (config.align || "right");

  const handleCellClick = (e) => {
    e.stopPropagation(); // Prevent row click when clicking on cell
    if (onCellClick && config.field) {
      onCellClick({
        mainHeader,
        subHeader: config.label,
        field: config.field,
      });
    }
    if (typeof config.onClick === 'function') {
      config.onClick(row);
    }
  };

  const cellStyles = {
    ...cellStyle,
    textAlign: dataAlignment,
    width: `${width}px`,
    minWidth: `${width}px`,
    maxWidth: `${width}px`,
    backgroundColor: cellStyle.backgroundColor || "inherit",
    position: isFirstColumn ? "sticky" : undefined,
    left: isFirstColumn ? 0 : undefined,
    zIndex: isFirstColumn ? 1 : undefined,
    fontWeight: cellStyle.fontWeight || (isTotalRow ? "bold" : "normal"),
    overflow: "visible",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
    padding: isEditable ? "4px 0px" : "4px 8px",
    borderRight: "1px solid rgba(224, 224, 224, 1)",
    ...(config.style || {}),
  };

  if (isEditable) {
    return (
      <MuiTableCell
        align={dataAlignment}
        onClick={handleCellClick}
        style={cellStyles}
      >
        <EditableCellComponent
          value={rawValue}
          row={row}
          config={config}
          currencySymbol={currencySymbol}
          onChange={(newValue) => {
            if (onCellChange) {
              onCellChange(rowIndex, config.field, newValue);
            }
          }}
          onBlur={() => {}}
          isTotalRow={isTotalRow}
          fontWeight={cellStyle.fontWeight}
        />
      </MuiTableCell>
    );
  }

  return (
    <MuiTableCell
      align={dataAlignment}
      onClick={handleCellClick}
      style={cellStyles}
    >
      {displayValue}
    </MuiTableCell>
  );
};

